export default "__VITE_ASSET__ovtm1KIJ__"